var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewfeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 10H12.4999M9.99992 7.5V12.5M3.33325 5V4.16667C3.33325 3.94566 3.42105 3.73369 3.57733 3.57741C3.73361 3.42113 3.94557 3.33334 4.16659 3.33334H4.99992M9.16659 3.33334H10.8333M14.9999 3.33334H15.8333C16.0543 3.33334 16.2662 3.42113 16.4225 3.57741C16.5788 3.73369 16.6666 3.94566 16.6666 4.16667V5M16.6666 9.16667V10.8333M16.6666 15V15.8333C16.6666 16.0543 16.5788 16.2663 16.4225 16.4226C16.2662 16.5789 16.0543 16.6667 15.8333 16.6667H14.9999M10.8333 16.6667H9.16659M4.99992 16.6667H4.16659C3.94557 16.6667 3.73361 16.5789 3.57733 16.4226C3.42105 16.2663 3.33325 16.0543 3.33325 15.8333V15M3.33325 10.8333V9.16667",
    stroke: "#667085",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewfeature);
export default __webpack_public_path__ + "static/media/new feature.2ef857e5e31e9122c7eb3712c2519c38.svg";
export { ForwardRef as ReactComponent };